module.exports = __webpack_public_path__ + "img/d.a3e0d961.jpg";